export const LoggedOut = () => {
    return <main>
        <div className="main">
            <h1>You have been logged out</h1>
            <div>
            <p>Click here to go visit the <a href="/">homepage</a></p>
            </div>
        </div>
    </main>
}

export default LoggedOut